import React from 'react'
import { Button, Card, Col, Container, FormControl, InputGroup, Row } from 'react-bootstrap'

const FaqVideos = () => {
    const videos = [
        {
            title: 'Live Online Courses',
            text: 'Learn from the comfort of your home with our live online courses.',
            link: 'Explore Courses',
            color: '#007bff'
        },
        {
            title: 'Recorded Courses',
            text: 'Access our library of recorded courses at your convenience.',
            link: 'Browse Library',
            color: '#28a745'
        },
        {
            title: 'Free Resources',
            text: 'Explore our free resources to enhance your learning experience.',
            link: 'Discover More',
            color: '#dc3545'
        },
        {
            title: 'Community Support',
            text: 'Join our community for support and networking opportunities.',
            link: 'Join Now',
            color: '#ffc107'
        },
        {
            title: 'Expert Instructors',
            text: 'Learn from industry experts with years of experience.',
            link: 'Meet Instructors',
            color: '#17a2b8'
        },
        {
            title: 'Flexible Scheduling',
            text: 'Choose a schedule that works best for you.',
            link: 'View Schedule',
            color: '#6610f2'
        }
    ];


    const [videoSearch, setVideoSearch] = React.useState('');
    const [filteredVideos, setFilteredVideos] = React.useState(videos);

    const handleVideoSearch = (event) => {
        const query = event.target.value.toLowerCase();
        setVideoSearch(query);
        if (!query) {
            setFilteredVideos(videos);
        } else {
            setFilteredVideos(
                videos.filter(
                    v =>
                        v.title.toLowerCase().includes(query) ||
                        v.text.toLowerCase().includes(query)
                )
            );
        }
    };
    console.log(filteredVideos);
    return (
        <div className="bg-gradient min-vh-100" style={{ background: 'linear-gradient(135deg, #e0eafc 0%, #cfdef3 100%)' }}>
            {/* Header */}
            <div className="py-5 text-center bg-primary text-white shadow-lg rounded-bottom-4">
                <h1 className="fw-bold mb-3 display-4">How can we help?</h1>
                <p className="lead mb-4 fs-5">Find answers, resources, and support for your journey.</p>
                <form className="d-flex col-xl-6 col-lg-6 col-md-6 col-sm-10 col-10 mx-auto  justify-content-center" onSubmit={e => e.preventDefault()}>
                    <InputGroup className="w-100 shadow-sm">
                        <FormControl
                            name="search"
                            type="text"
                            placeholder="Search videos..."
                            value={videoSearch}
                            onChange={handleVideoSearch}
                            className="rounded-start-pill px-4 py-3 border-0"
                        />
                        <Button variant="light" className="rounded-end-pill ms-2 px-4 fw-semibold shadow-sm">Search</Button>
                    </InputGroup>
                </form>
            </div>

            <Container className="g-3 my-5 py-5">
                <Row className="justify-content-center">
                    {filteredVideos.length === 0 ? (
                        <Col xs={12} className="text-center text-muted py-5">
                            <p>No videos found.</p>
                        </Col>
                    ) : (
                        filteredVideos.map((item, index) => (
                            <Col md={6} lg={4} className="mb-4" key={index}>
                                <Card
                                    className="align-items-center border-0 shadow-lg h-100"
                                    style={{
                                        background: `linear-gradient(135deg, ${item.color}22 0%, #fff 100%)`,
                                        borderRadius: '1rem'
                                    }}
                                >

                                    <div className="w-100" style={{ borderTopLeftRadius: '1rem', borderTopRightRadius: '1rem', overflow: 'hidden' }}>
                                        <iframe width="593" height="229" src="https://www.youtube.com/embed/rjT3vmeRy58" 
                                        title="Cybersecurity Roadmap 2023 ! #cybersecurity" 
                                        frameborder="0" 
                                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" 
                                        referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
                                    </div>
                                    <Card.Body className="text-center">
                                        <Card.Title className='fw-bold mb-2' style={{ color: item.color }}>{item.title}</Card.Title>
                                        <Card.Text className='mb-3 text-secondary'>{item.text}</Card.Text>
                                        <Button
                                            className='rounded-pill px-4 fw-semibold'
                                            style={{ background: item.color, border: 'none' }}
                                            href="#"
                                        >
                                            {item.link}
                                        </Button>
                                    </Card.Body>
                                </Card>
                            </Col>
                        ))
                    )}
                </Row>

            </Container>


        </div>
    )
}

export default FaqVideos
